module.exports = __webpack_public_path__ + "img/rocket_game.3f837637.png";